<template>
<div style="display: flex; flex-direction: column;">
    <v-data-table
        hide-default-footer
        :headers="processHeaders"
        :items="retrieveProcessItems()"
        disable-pagination
        sort-by="creationDate"
        :sort-desc="true"
        class="border-bottom padded-table"
        
    >
      <template v-slot:body="{items}">
        <tbody>
        <tr v-for="item in items"
            :key="item.id"
            @mouseover="selectItem(item)"
            @mouseleave="unSelectItem(item)">
          <td>

            <div class="innerLink padded-cell"
              v-if="!editIndicator[item.uuid].editFN"
              @click="editModel(item)">
              <v-icon color="secondary">mdi-file-document-outline</v-icon>
              {{ item.fileName }}
            </div>
            <v-text-field
                v-if="editIndicator[item.uuid].editFN"
                v-model="item.fileName"
                label="Dateiname"
                required
                @keyup.enter="submitFileName(item)"
              ></v-text-field>
              <v-btn v-if="item.isOwn && !editIndicator[item.uuid].editFN" color="gray_m" style="width:10px" small text @click="editProcess(item)"><v-icon>mdi-pencil</v-icon></v-btn>
          </td>
          <td>
            <div class="pl-5">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-if="item.surveys.length > 0" link class="chip font-weight-black" color="primary"
                            @click="previewSurveys(item)" v-bind="attrs" v-on="on">
                      {{item.surveys.length}}
                    </v-chip>
                    <v-chip v-else class="chip" color="gray_s" text-color="gray_m">{{item.surveys
                        .length}}</v-chip>
                  </template>
                  <span>Umfrage ansehen</span>
                </v-tooltip>
              </div>
          </td>
          <td style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            <span color="gray_3">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <span class="cursor-default" v-bind="attrs" v-on="on">
                        <v-avatar
                            color="gray_2"
                            size="32"
                            style="color: #fff;"
                        >{{initials(item.initiator)}}</v-avatar>
                      </span>
                  </template>
                  <span>{{ item.initiator }}</span>
                </v-tooltip>
            </span>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="date cursor-default" v-bind="attrs" v-on="on" style="vertical-align: center;">{{ new
                Date(item.creationDate).toLocaleString('de-DE', {day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
              </template>
              <span>{{ new Date(item.creationDate).toLocaleString('de-DE') }}</span>
            </v-tooltip>
          </td>
          <td style="max-width: 80px;">
            <div v-if="item === selectedItem" class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="editModel(item)" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon> </v-btn>
                </template>
                <span>Bearbeiten</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.isOwn">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="deleteProcessModel(item)" v-bind="attrs"
                         v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                <span>Löschen</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.isOwn">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="changeProcessFolder(item)" v-bind="attrs"
                         v-on="on"><v-icon>mdi-folder-edit-outline</v-icon></v-btn>
                </template>
                <span>In Ordner verschieben</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.isOwn">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="downloadProcess(item)" v-bind="attrs"
                         v-on="on"><v-icon>mdi-file-download-outline</v-icon></v-btn>
                </template>
                <span>Prozess herunterladen</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>   
    <EditProcessDialog ref="editProcessDialog" />
    <process-download-option-choose-dialog ref="downloadDialog"/>
</div>
</template>

<script>

import { Splitpanes, Pane } from 'splitpanes'
import PreviewSurveyProcessModelDialog from '../PxQuestionSurvey/PXSurveyPage/PreviewSurveyProcessModelMenu.vue';
import ConfirmDialog from "@/components/common/ConfirmDialog";
import EditProcessDialog from './EditProcessDialog.vue';
import ProcessDownloadOptionChooseDialog from './ProcessDownloadOptionChooseDialog.vue';
import processModelingService from '../ProcessModeling/process-modeling-service';
import BpmnJS from "prime-custom-modeling"
export default {
  components: { 
  Splitpanes, 
  Pane,
  PreviewSurveyProcessModelDialog,
  ConfirmDialog,
    EditProcessDialog,
    ProcessDownloadOptionChooseDialog, },
  name: "ProcessList",
  props: ['processes', 'editIndicator', 'tab', 'folders'],
  data() {
    return {
      noEditor: "No current editor",
      loadingProgress: 0,
      processHeaders: [

          {
            text: 'Prozessname',
            align: 'start',
            value: 'fileName',
            width: '45%'
          },
          { text: 'Umfragen', value: 'surveys', align: 'start', width: '10%' },
          { text: 'Ersteller', value: 'initiator', align: 'start',  width: '10%' },
          { text: 'Erstellt am', value: 'creationDate', dataType: "Date", align: 'start',  width: '15%'},
          { text: 'Aktionen', value: 'actions'},
      ],
      search: '',
      showCreateDialog: false,
      showImportDialog: false,
      viewSurveys: false,
      selectedItem: null,
      expanded: [],
      singleExpand: false,
    };
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    ownProcesses(){
      if(this.processes == null) return [];
      if(this.processes.length > 0){
        return this.processes.filter(elem => elem.isOwn == true);
      }
    },
    sharedProcesses(){
      if(this.processes == null) return [];
      if(this.processes.length > 0){
        return this.processes.filter(elem => elem.isOwn == false);
      }
    },
    reviewProcesses(){
      return this.processes.filter(process => process.reviewRequests && process.reviewRequests.length > 0);
    }
  },
  mounted() {
    //this.retrieveProcesses();
    // Set Table Header Max-Width
    let ths = document.querySelectorAll('th>span');
    for (let elem of ths) {
      if (elem.innerHTML.length > 18) {
        /* elem.parentElement.setAttribute("style", "display:flex;"); */
        elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
      }
    }
  },
  methods: {
    editProcess(item){
      let canEdit = item.isOwn;
      this.$refs.editProcessDialog
        .open(item, this.folders, true, canEdit)
        .then(() => {
          this.$emit('reload');
        });
      
    },
    closeSurveyPreview(){
      this.selectedItem = null;
      this.viewSurveys = false;
    },
    editModel(val){
      if(this.tab == 3){
        this.$router.push('/modelReview/'+val.uuid);
      }else{
        this.$router.push('/modelEdit/'+val.uuid);
      }
      
    },
    deleteProcessModel(val){
      this.$emit("deleteProcessModel", val);
    },
    processCharacteristic(item){
      this.$emit("processCharacteristic", item);
    },
    previewSurveys(item){
      this.$emit('viewSurveys', item);
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem(item) {
      this.selectedItem = false;
    },
    initials(email){
      let initials = email.substring(0,2).toUpperCase();
      return initials;
    },
    changeProcessFolder(item){
        this.$emit("changeProcessFolder", item);    
    },
    clickColumn(slotData) {
      const indexRow = slotData.index;
      const indexExpanded = this.expanded.findIndex(i => i === slotData.item);
      if (indexExpanded > -1) {
        this.expanded.splice(indexExpanded, 1)
      } else {
        this.expanded.push(slotData.item);
      }
    },
    retrieveProcessItems(){
      if(this.tab == 0){
        return this.processes;
      }else if( this.tab == 1){
        return this.ownProcesses;
      }else if(this.tab == 2){
        return this.sharedProcesses;
      }else if(this.tab == 3){
        return this.reviewProcesses;
      }
    },
    downloadProcess(item){
      this.$refs.downloadDialog
        .open()
        .then((option) => {
          processModelingService.getProcessXml(item.uuid).then((res) => {
            if(res && res.data && option == "XML"){
              this.downloadXML(res.data, item.fileName)
            }else if(res && res.data && option == "PDF"){
              const viewer = new BpmnJS();

              viewer.importXML(res.data, (err) => {
                if (err) {
                  ('Error parsing BPMN XML:', err);
                } else {
                  console.log('BPMN XML parsed successfully');
                  
                  // Generate the SVG from the BPMN diagram
                  viewer.saveSVG({ format: true },(err, svg) => {
                    if (err) {
                      console.log('Error generating SVG:', err);
                    } else {
                      this.createPDFandDownload(this.correctSvgDimensions(svg), item.fileName)
                    }
                  });
                }
              });
            }
          })
        });
    },
    correctSvgDimensions(svgContent) {
      // Match the SVG with viewBox, width, and height attributes
      const viewBoxRegex = /<svg[^>]*viewBox="([^"]*)"/;
      const widthHeightRegex = /<svg[^>]*width="([^"]*)"[^>]*height="([^"]*)"/;

      // Extract viewBox values
      const matchViewBox = svgContent.match(viewBoxRegex);
      if (matchViewBox) {
        const viewBox = matchViewBox[1].split(' '); // Get viewBox values [x, y, width, height]

        // Check if viewBox values are 0 or invalid, and update them
        if (parseFloat(viewBox[2]) === 0 || parseFloat(viewBox[3]) === 0) {
          const width = 300;  // Default width, adjust as needed
          const height = 200; // Default height, adjust as needed
          viewBox[2] = width;
          viewBox[3] = height;
          
          // Replace the viewBox in the SVG content
          svgContent = svgContent.replace(viewBoxRegex, `<svg viewBox="${viewBox.join(' ')}"`);
        }
      }

      // Update width and height attributes if necessary
      const matchWidthHeight = svgContent.match(widthHeightRegex);
      if (matchWidthHeight) {
        svgContent = svgContent.replace(widthHeightRegex, `<svg width="300" height="200"`);
      } else {
        svgContent = svgContent.replace(/<svg/, `<svg width="300" height="200"`);
      }

      return svgContent;
    }
    ,

    downloadXML(xml, fileName) {
      const file = new Blob([xml], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = fileName + ".bpmn";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    createPDFandDownload(svg, filename) {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          "Prozessmodell für " + filename,
          {
            svg: svg,
            width: 800,
            height: 500,
            style: "centering",
          },
        ],
        styles: {
          centering: {
            alignment: "center",
          },
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download(filename + ".pdf");
    },
  }
};
</script>
<style scoped>
.innerTable{
  margin-top: 0px !important;
}
:deep table{
  margin-top: 0px !important;
}
.white{
  color: var(--v-secondary-base) !important;
}
.v-tab--active{
  color:initial;
}
.v-tab--active > .v-chip{
  background-color: var(--v-secondary-base) !important;
  color: #F5F5F5 !important;
}
#tab{
  max-width:unset;
}
#tab.active{
  font-size: 10rem;
}
.chip{
  margin-left: 10px;
}
#chip{
  margin-left: 10px;
}
#datatable{
  position: inherit !important;
}
:deep td:first-child {
  width: 40vw;
}
:deep td:last-child {
  min-width: 180px;
  width: 10vw;
}
:deep td:last-child button.v-size--small {
  min-width: unset;
  width: 36px;
}
:deep th {
  height: 60px !important;
}

:deep .sv_q.sv_qstn .table {
  margin-top: 0rem;
}
:deep .sv_header__text h3 {
  font-size: 2rem !important;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table {
  display: flex;
  flex-direction: column-reverse;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tr {
  display: flex;
  flex-direction: column;
  width: 100%;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table thead td {
  display: none;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table thead tr {
}
:deep .sv_main .sv_container .sv_body .sv_p_root table th {
  width: 100%;
  height: 41px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 3em;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody tr {
  height: 60px;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody td {
  height: 60px !important;
  padding: 0;
  line-height: 1.3em;
  padding-left: 10px;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody td:first-child span {
  height: 60px;
  display: flex;
  align-items: center;
}
:deep .sv_qstn label.sv_q_m_label {
  position: unset !important;
  display: flex !important;
  height: 40px;
  padding: 0;
  align-items: center;
}

/* Error Message */
:deep .sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"]) {
  width: 100%;
}
.isExpanded {
 background-color: rgba(255,100,9,0.4) 
}
.innerLink{
  display: inline; 
  cursor: pointer
}
.innerLink:hover{
  color:var(--v-primary-base);
}
:deep .text-start{
  color: green;
}
.padded-table .padded-cell {
  padding-left: 50px;
}
:deep th:first-child{
  padding-left: 65px !important;
}
:deep thead th:first-child {
  border-radius: 0 0 0 0;
}
:deep thead th:lsat-child {
  border-radius: 0 0 0 0;
}
</style>